// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
/* eslint-disable */
export const VERSION = {
    "dirty": true,
    "raw": "bf4a184-dirty",
    "hash": "bf4a184",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "bf4a184-dirty",
    "semverString": null,
    "version": "0.0.1"
};
/* tslint:enable */
